import { Component, h, Host, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { CmsLink } from '../../../types/global';

export interface UiCmsContactChannelsMiscellaneousBody {
  iconPath: string;
  link: CmsLink;
  headline: string;
  text: string;
  iconType: 'system' | 'content';
}

@Component({
  tag: 'ui-cms-contact-channels-miscellaneous',
  styleUrl: 'ui-cms-contact-channels-miscellaneous.scss',
})
export class UiCmsContactChannelsMiscellaneous {
  @Prop({ mutable: true }) body: UiCmsContactChannelsMiscellaneousBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop() inverted: boolean;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  private handleTracking(): void {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: `Click on ${this.body.link.title}`,
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.link.title,
        target: this.body.link.src,
      },
      category: {
        area: 'Content',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  render() {
    return (
      <Host class="channel">
        <div class="channel-contactbox">
          <div class="up">
            <h4
              class={{
                'sd-headline': true,
                'sd-headline--inline': true,
                'sd-headline--size-3xl': true,
                'sd-headline--inverted': this.inverted,
              }}
            >
              {this.body.iconPath && (
                <sd-icon
                  library={window.ui.cmsState.iconLibrary}
                  name={this.body.iconPath}
                  color={this.inverted ? 'white' : 'primary'}
                ></sd-icon>
              )}
              {this.body.headline}
            </h4>
            <p
              class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}
              innerHTML={this.body.text}
            ></p>
          </div>
          <div class="down">
            {this.body.link && (
              <sd-button
                href={this.body.link.src}
                target={this.body.link.target}
                onClick={() => this.handleTracking()}
                className="button"
                variant="primary"
                inverted={this.inverted}
                size="lg"
                type="button"
              >
                <span aria-hidden={this.body.link.ariaLabel ? 'true' : 'false'}>{this.body.link.title}</span>
                <span class="sr-only">{this.body.link.ariaLabel}</span>
              </sd-button>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
